import { View } from 'react-native';

import { Skeleton } from '@/components/ui/Skeleton';
import { Surface } from '@/components/ui/Surface';

/** Loading placeholder matching {@link ActiveRunCard}'s shape. */
export function ActiveRunCardSkeleton() {
  return (
    <Surface className="gap-3 p-4">
      <View className="flex-row items-center justify-between">
        <Skeleton className="h-3 w-2/5 rounded-md" />
        <Skeleton className="h-3 w-12 rounded-md" />
      </View>
      <Skeleton className="h-6 w-3/5 rounded-md" />
      <Skeleton className="h-3 w-1/2 rounded-md" />
      <Skeleton className="my-1 h-1.5 w-full rounded-full" />
      <Skeleton className="h-11 w-full rounded-xl" />
    </Surface>
  );
}
